<script lang="ts">
  import '../styles/index.css';

  import { QueryClient, QueryClientProvider } from '@tanstack/svelte-query';
  import { browser, dev } from '$app/environment';
  import DraftMode from '$components/draft-mode.svelte';
  import { nostoSession, sendNostoEvent } from '$lib/nosto';
  import { user } from '$lib/stores/user';
  import { region } from '$lib/region';

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        enabled: browser
      }
    }
  });

  $: sessionToken = $nostoSession || '';

  $: if (sessionToken) {
    sendNostoEvent({
      type: 'sendPage',
      nostoSession: sessionToken,
      target: window.location.href,
      region: $region
    });

    sendNostoEvent({
      type: 'sendUser',
      nostoSession: sessionToken,
      target: window.location.href,
      user: {
        firstName: $user?.firstName || '',
        lastName: $user?.lastName || ''
      },
      region: $region
    });
  }
</script>

<QueryClientProvider client={queryClient}>
  <DraftMode />
  <slot />
</QueryClientProvider>

<!-- Tailwind responsive indicator -->
{#if dev}
  <div
    class="fixed bottom-1 right-1 z-50 flex p-1 items-center justify-center rounded-xs bg-primary text-highlight font-mono text-xs/none"
  >
    <div class="block sm:hidden">xs</div>
    <div class="hidden sm:block md:hidden lg:hidden xl:hidden 2xl:hidden">sm</div>
    <div class="hidden md:block lg:hidden xl:hidden 2xl:hidden">md</div>
    <div class="hidden lg:block xl:hidden 2xl:hidden">lg</div>
    <div class="hidden xl:block 2xl:hidden">xl</div>
    <div class="hidden 2xl:block">2xl</div>
  </div>
{/if}
